<template>
  <div
    class="good pointer"
    @click="toGoodDetail"
    :class="{ isRight: (index + 1) % 4 === 0 }"
  >
    <div class="good-cover">
      <img
        :src="good.productmallWaresImage"
        v-if="good.productmallWaresImage"
      />
      <img v-else :src="$oss('common/empty-img.png')" />
    </div>
    <div class="good-desc">
      <div class="good-name ellipsis">
        {{ good.productmallWaresName }}{{ good.productmallWaresName }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    good: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    toGoodDetail() {
      this.$jump.push({
        name: "deviceDetail",
        query: { id: this.good.resourceId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$max-width: 215px;
.good {
  border: 1px solid $border-color;
  padding: 10px;
  margin-bottom: 15px;
  margin-right: 15px;
  width: $max-width;
  background: white;
  &.isRight {
    margin-right: 0;
  }
  &-cover {
    width: 100%;
    height: 150px;
    overflow: hidden;
    margin-bottom: 10px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.5s ease-in-out 0s;
    }
  }
  &-desc {
    text-align: center;
    background: white;
  }
}
.good:hover .good-cover img {
  transform: scale(1.05);
}
</style>
